// src/utils/TokenManager.ts
// Replace with your actual path

import { refreshTokeApi } from "../service/login/loginService";
import { clearAuthStorage } from "./storageUtils";


export class TokenManager {

public static async checkAndRedirectIfExpired(): Promise<boolean> {
  try {
    let token = localStorage.getItem("token");
    let expTime = localStorage.getItem("TokenExpTime") || sessionStorage.getItem("TokenExpTime");

    if (!token || !expTime) {
      this.redirectToLogin();
      return false;
    }

    // "Keep me signed in" enforcement: if the user did NOT opt in, the session
    // must not survive a browser restart. sessionStorage is cleared when the
    // browser/tab closes, so its absence means a fresh browser session began.
    const rememberMe = localStorage.getItem("rememberMe") === "true";
    const sessionActive = sessionStorage.getItem("sessionActive") === "true";
    if (!rememberMe && !sessionActive) {
      this.redirectToLogin();
      return false;
    }
    // Keep the current browser session marked as active for later checks.
    sessionStorage.setItem("sessionActive", "true");

    const isExpired = this.isTokenExpired(expTime);

    if (isExpired) {
      console.debug("Access token expired. Refreshing...");

      try {
        // ⛔ ⛔ ⛔ DO NOT send refresh token manually
        const res = await refreshTokeApi({rememberMe:localStorage.getItem("rememberMe")==="true"?true:false}); // Axios withCredentials = true

        const newToken = res?.data?.Result?.token ?? "";
        const newExpTimeInMin = res?.data?.Result?.expTimeInMinutes ?? 10;

        const newExpMillis =
          Date.now() + newExpTimeInMin * 60 * 1000;

        // The whole app reads the access token from localStorage, so the
        // refreshed token must go there regardless of the rememberMe flag.
        // The rememberMe / sessionActive guard above already governs whether a
        // non-remembered session is allowed to reach this refresh at all.
        localStorage.setItem("token", newToken);
        localStorage.setItem("TokenExpTime", newExpMillis.toString());

        // Check again
        if (this.isTokenExpired(newExpMillis.toString())) {
          this.redirectToLogin();
          return false;
        }

        return true;
      } catch (err) {
        console.error("Error refreshing token", err);
        this.redirectToLogin();
        return false;
      }
    }

    return true;
  } catch (error) {
    console.error("Token check error", error);
    this.redirectToLogin();
    return false;
  }
}

  private static isTokenExpired(expTime: string): boolean {
    const expMillis = parseInt(expTime, 10);
    if (isNaN(expMillis)) {
      console.error("TokenExpTime is not a valid number");
      return true;
    }

    const currentMillis = Date.now();
    return currentMillis >= expMillis;
  }


  private static redirectToLogin(): void {
    clearAuthStorage();     // clear auth data, keep UI preferences (theme/mode)
    sessionStorage.clear(); // optional: clear sessionStorage
    window.location.href = "/login"; // or your actual login path
  }
}
